import { useNavigate } from "react-router-dom";
import useFetch from "@/lib/useFetch";
import { PageHeader, Loading, ErrorState, EmptyState } from "@/components/common";
import { brl } from "@/lib/format";
import { AlertTriangle, ChevronRight, ShieldCheck, Users } from "@/components/icons";

const sevStyle = {
  alta: "bg-white",
  media: "bg-white",
  baixa: "bg-white",
};
const sevBadge = {
  alta: "bg-bad-soft text-bad",
  media: "bg-warn-soft text-warn",
  baixa: "bg-info-soft text-info",
};
// Rótulo exibido no selo. A chave (`alta/media/baixa`) continua minúscula na
// lógica — só o texto renderizado ganha acentuação correta.
const sevRotulo = { alta: "ALTA", media: "MÉDIA", baixa: "BAIXA" };

export default function Atencao() {
  const navigate = useNavigate();
  const { data, loading, error, reload } = useFetch("/atencao");

  if (loading) return <Loading />;
  if (error) return <ErrorState onRetry={reload} />;

  const items = data.items || [];
  const teamFocos = ["vendedores_abaixo_meta", "baixa_atividade"];
  const n = data.count;

  return (
    <div>
      <PageHeader title="Requer atenção" subtitle={`${n} ${n === 1 ? "ponto que exige ação" : "pontos que exigem ação"}`} />
      {items.length === 0 ? (
        <EmptyState icon={ShieldCheck} title="Tudo sob controle" subtitle="Nenhuma pendência crítica no seu funil no momento." />
      ) : (
        <div className="space-y-3">
          {items.map((it, i) => {
            const isTeam = teamFocos.includes(it.foco);
            return (
              <div key={i} onClick={() => !isTeam && navigate(`/foco/${it.foco}`)} data-testid={`atencao-${it.foco}`}
                className={`rounded-xl border border-black/5 p-4 flex items-center gap-4 transition-colors ${sevStyle[it.severidade] || "bg-white"} ${!isTeam ? "cursor-pointer hover:bg-slate-50" : ""}`}>
                <div className="w-10 h-10 rounded-lg flex items-center justify-center shrink-0" style={{ background: "#F3F8FB" }}>
                  {isTeam ? <Users className="w-5 h-5" style={{ color: "#62717F" }} /> : <AlertTriangle className="w-5 h-5" style={{ color: "#62717F" }} />}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="font-semibold text-navy text-sm">{it.titulo}</span>
                    <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${sevBadge[it.severidade]}`}>{sevRotulo[it.severidade] || (it.severidade || "").toUpperCase()}</span>
                  </div>
                  <p className="text-[13px] text-slate-600 mt-0.5">{it.detalhe}</p>
                  {it.extra && Array.isArray(it.extra) && (
                    <div className="flex flex-wrap gap-1.5 mt-2">
                      {it.extra.slice(0, 5).map((e, j) => (
                        <button key={j} onClick={(ev) => { ev.stopPropagation(); navigate(`/membro/${e.id}`); }}
                          className="text-[13px] bg-white border border-[#D5DEE5] rounded-full px-2 py-0.5 hover:bg-slate-50">
                          {e.nome}{e.pct != null ? ` · ${e.pct}%` : e.atividades_7d != null ? ` · ${e.atividades_7d} ativ.` : ""}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
                <div className="text-right shrink-0">
                  <div className="text-lg font-semibold text-navy">{it.count}</div>
                  {it.valor > 0 && <div className="text-xs text-muted-foreground">{brl(it.valor)}</div>}
                </div>
                {!isTeam && <ChevronRight className="w-4 h-4 text-slate-400 shrink-0" />}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
